import { validIdMaker } from "../valid-id-maker";
import { QuestionsComponent } from "../../cart";
import { CheckoutComponent } from "../../checkout/checkout.component";
import { CheckoutPaymentType } from "../../_models/checkout-payment-type";
import { CashComponent } from "../../admin/components/cash/cash.component";

const randomFrom = <T>(arr: T[]): T =>
  arr[Math.floor(Math.random() * arr.length)];

/** To add more component class add the class name as a property
 * name, and it will be an object with:
 * data : the form data as an object
 *
 */
const formDataByClass: Record<
  string,
  {
    data: any;
    callAfter?: any;
    formObjectName: string;
    customFillFunction?: (any) => any;
  }
> = {
  CreateChildComponent: {
    data: {
      birthday: "2002-09-14",
      firstName: randomFrom(["נורח", "מומי", "שאול", "אבי"]),
      gender: "זכר",
      lastName: "כחול",
      layer: { layerId: 9, layerName: "ט'" },
      nest: { nestId: 651, nestCode: "17", nestName: "רמתיים" },
      originCountryChild: { id: 88, name: "ישראל", sortOrder: 1 },
      originCountryParent: { id: 88, name: "ישראל", sortOrder: 1 },
      personalId: validIdMaker(),
      phone: "054-6731111",
    },
    formObjectName: "model",
    callAfter: "saveChild",
  },
  QuestionsComponent: {
    data: {
      // "האם החניך/ה צמחוני/ת, בשרי/ת או טבעוני/ת?  פרט/י": {
      //   questionId: 162137,
      //   answerId: 112917,
      //   answerText: "טבעוני/ת",
      // },
      "הנני לאשר שלבני/בתי אין הגבלות בריאותיות ואינו רגיש לחומרים מסויימים. אנא פרט/י אם כן":
        "כן",
      "הנני לאשר כי כל הפרטים שמסרתי נכונים, על החתום (שם ההורה בלבד)": "כן",
      "האם לחניך/ה יש מגבלות אכילה הדורשות טיפול מיוחד?": "כן",
      "מה שם הקבוצה של החניכ/ה? אם אינך יודע את שם הקבוצה נא לכתוב את שם בית הספר והכיתה בה הוא לומד.":
        "תפוח",
      'אישור הורים להשתתפות בפעילות\nהנני לאשר לבני/בתי להשתתף בפעילות הנוע"ל שאליה נרשם/ה':
        true,
    },
    formObjectName: "model",
    callAfter: "addToCart",
    customFillFunction: (componentRef: QuestionsComponent) => {
      const selectQuestions = componentRef.event.questions.filter(
        (q) => q.answers && q.answers.length > 1
      );
      for (const question of selectQuestions) {
        componentRef.model[question.questionText] = randomFrom(
          question.answers
        );
      }
    },
  },
  SearchComponent: {
    data: { "#main-search-field": "גילה", firstName: "גילה" },
    formObjectName: "model",
    callAfter: "$$devSearchChildFromInput",
  },
  FreePayComponent: {
    data: {
      "#free-pay-firstName": "אבי",
      "#free-pay-lastName": "נמני",
      "#free-pay-email": "avi@nimni",
      "#free-pay-phone": "054-6777777",
    },
    formObjectName: "model",
  },
  CheckoutComponent: {
    data: {
      "#firstName": "אבי",
      "#lastName": "נמני",
      "#email": "avi@nimni",
      "#phone": "054-6777777",
    },
    formObjectName: "model",
    customFillFunction: (componentRef: CheckoutComponent) => {
      if (!componentRef.confirmation1 || !componentRef.confirmation2) {
        componentRef.confirmation1 = true;
        componentRef.confirmation2 = true;
        componentRef.numberOfPayments = 1;
        componentRef.paymentType = CheckoutPaymentType.CheckOrCash;
      }
    },
  },
  CashComponent: {
    data: {
      "#cash-first-name": "אבי",
      "#cash-last-name": "נמני",
      "#cash-email": "avi@nimni",
      "#cash-phone": "054-6777777",
    },
    formObjectName: "model",
    customFillFunction: (componentRef: CashComponent) => {
      componentRef.formGroupObj.patchValue({
        firstName: "אבי",
        lastName: "נמני",
        email: "avi@nimni",
        phone: "054-6777777",
      });
    },
  },
};

export const getDataByComponentClass = (
  componentClassName: string
): {
  callAfter: any;
  formData: any;
  formObjectName: string;
  customFillFunction?: (any) => any;
} => {
  const classData = formDataByClass[componentClassName] || {
    callAfter: null,
    data: {},
    formObjectName: "",
  };
  return {
    formData: classData.data,
    callAfter: classData.callAfter,
    formObjectName: classData.formObjectName,
    customFillFunction: classData.customFillFunction,
  };
};



// WEBPACK FOOTER //
// ./src/app/_helpers/auto-fill-forms/auto-fill-forms-data.ts